import { get, post } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;
const tasksServiceUrl = env.REACT_APP_TASKS_API_URL;

const loadDocumentTasks = (documentId, siteId) => {
  return get(`${url}/leasingdocument/${documentId}/${siteId}/tasks`);
};

const postTasks = filters => {
  return post(url + '/documentTasks/tasks', filters); //this is wrong! For the searching,you should use querystrings.
};

const getClientCategories = () => {
  return get(url + '/documentTasks/tasks/client-categories');
};

const getTaskOptions = () => {
  return get(url + '/documentTasks/tasks/options');
};

const getTaskResponsibles = () => {
  return get(url + '/documentTasks/tasks/responsibles');
};

const loadResponsiblesForSingleTask = (taskId, search) => {
  return get(url + '/documentTasks/tasks/loadResponsiblesForSingleTask?taskId=' + taskId + '&search=' + search); //Resources naming: resources must be noun not verbs
};

const getTaskTypes = () => {
  return get(url + '/documentTasks/tasks/types');
};

const getTaskStates = () => {
  return get(url + '/documentTasks/tasks/states');
};

const getTaskStatuses = () => {
  return get(url + '/documentTasks/tasks/statuses');
};

const getTasksCommentsConfig = () => {
  return get(url + `/documentTasks/taskscommentsconfig`);
};

const pauseTask = (task, comment, selectedReasons) => {
  const body = {
    ...task,
    additionalData: {
      comment: comment,
      reasons: JSON.stringify(selectedReasons),
      taskWorkId: task.taskWorkId
    }
  };
  return post(tasksServiceUrl + '/tasks/pause-task', body);
};

const startTask = task => {
  return post(tasksServiceUrl + '/tasks/start-task', task);
};

const updateTask = (task, userId) => {
  return post(tasksServiceUrl + '/tasks/update-user-task-allocation', {
    taskId: task.taskId,
    processId: task.processId,
    userId
  });
};

const updateTaskPriority = input => {
  return post(tasksServiceUrl + '/tasks/update-task-priority', {
    taskId: input.taskId,
    processId: input.processId,
    isHighPriority: input.isHighPriority
  });
};

const exp = {
  loadDocumentTasks,
  postTasks,
  getTaskOptions,
  getClientCategories,
  getTaskResponsibles,
  loadResponsiblesForSingleTask,
  getTaskStates,
  getTaskTypes,
  getTaskStatuses,
  updateTask,
  startTask,
  getTasksCommentsConfig,
  pauseTask,
  updateTaskPriority
};
export default exp;
